import React from "react";
import { Alert } from "@mantine/core";

interface SensitivityWarningProps {
  /** Optional custom message */
  message?: string;
  /** Alert color (default: warning) */
  color?: string;
  /** Show/hide the warning */
  show?: boolean;
  /** Additional CSS classes */
  className?: string;
}

/**
 * Security warning component for sensitive financial information
 * Used to warn users that originator bank details are sensitive and won't be saved
 */
const SensitivityWarning: React.FunctionComponent<SensitivityWarningProps> = ({
  message,
  color = "warning",
  show = true,
  className = "",
}) => {
  if (!show) return null;

  const defaultMessage = (
    <>
      <strong>Sensitive Financial Information</strong>
      <br />
      Bank details contain sensitive financial information that must be handled with care. Only authorized personnel should view or modify these details. These credentials will not be saved and must be entered each time to ensure security.
    </>
  );

  return (
    <Alert color={color} className={`mb-4 ${className}`}>
      <div className="d-flex">
        <div className="flex-shrink-0">
          <i 
            className="fas fa-exclamation-triangle text-warning me-2" 
            style={{ fontSize: "1.2em" }}
          />
        </div>
        <div className="flex-grow-1">
          {message || defaultMessage}
        </div>
      </div>
    </Alert>
  );
};

export default SensitivityWarning;
